const apiUrl = process.env.REACT_APP_API_URL;
export const GetAllRankings = async (id_problema: string, origenTipo?: string) => {
    try {
        const url = origenTipo
            ? `${apiUrl}:8061/jutge/rankings?id_problema=${id_problema}&origen_tipo=${origenTipo}`
            : `${apiUrl}:8061/jutge/rankings?id_problema=${id_problema}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
